<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina
                Titlu="Devize in lucru"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="false"
              />
            </div>
          </template>
      <div class="filtre">
        <el-form @submit.prevent.native="refresh_info()">
          <el-row style="margin: 10px" class="input-group">
            <el-col class="input-element">
               <el-form-item label='Interval'>
                  <el-date-picker                            
                      v-model="Filters.Data"
                      type="daterange" size="small"
                      range-separator="-"
                      start-placeholder="Data inceput"
                      end-placeholder="Data sfarsit"
                      :picker-options="datePickerOptions"
                      format="dd/MM/yyyy" value-format="yyyy-MM-dd">
                  </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-button
                type="primary" size="small"
                native-type="submit"
                @click="refresh_info()"
              >
                Aplica
              </el-button>
              <el-button type="danger" native-type="submit" @click="reset()" size="small">
                Reseteaza
              </el-button>
            </el-col>
          </el-row>
        </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table el-table :data="Results">
      <el-table-column prop="Id" label="#"></el-table-column>
      <el-table-column label="Data consimtamant">
        <template slot-scope="scope">
          {{ scope.row.DataDeschiderii | DataOraFaraSec}}
        </template>
      </el-table-column>
      <el-table-column label="Data preluare">
        <template slot-scope="scope">
          {{ formatDate(scope.row.DataPreluareInLucru) ? formatDate(scope.row.DataPreluareInLucru) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="Numar" label="Numar"></el-table-column>
      <el-table-column prop="NumeClient" label="Client"></el-table-column>
      <el-table-column prop="ValoareDeviz" label="Valoare"></el-table-column>
      <el-table-column label="Consimtamant semnat">
        <template slot-scope="scope">
          {{ scope.row.SemnaturaConsimtamant == null ? "Nu" : "Da" }}
        </template>
      </el-table-column>
      <el-table-column label="Hotel">
        <template slot-scope="scope">
          {{ scope.row.Hotel == 0 ? "Nu" : "Da" }}
        </template>
      </el-table-column>
      <el-table-column v-if="device === 'computer'" fixed="right" align="right" label="Actiuni" width="200px">
        <template slot-scope="scope">
          <el-tooltip content="Print consimtamant">
            <el-button type="info" size="mini" icon="el-icon-printer" circle @click="print_consimtamant(scope.row.Id)"/>
          </el-tooltip>
          <el-tooltip content="Preview">
            <el-button type="primary" size="mini" icon="el-icon-view" circle @click="preview(scope.row.Id)"/>
          </el-tooltip>  
          <el-tooltip content="Inchide devizul si anuleaza programarea">
            <el-button type="warning" size="mini" icon="el-icon-close" circle @click="inchide(scope.row.Id)"/>
          </el-tooltip> 
          <el-tooltip content="Anuleaza devizul (programarea ramane)">
            <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="anuleaza(scope.row.Id)"/>
          </el-tooltip>
          
          <!-- <el-tooltip content="Print deviz">
            <el-button type="info" size="mini" icon="el-icon-printer" circle @click="print_deviz(scope.row.Id)"/>
          </el-tooltip>
          <el-tooltip content="Print inspectie">
            <el-button type="warning" size="mini" icon="el-icon-printer" circle @click="print_inspectie(scope.row.Id)" />
          </el-tooltip>           -->
        </template>
      </el-table-column>
            <el-table-column v-else fixed="right" label="Actiuni" width="70px" type="expand">
        <template slot-scope="scope">
          <div class="phone-btn">
          <el-tooltip content="Print consimtamant">
            <el-button type="info" size="mini" icon="el-icon-printer" circle @click="print_consimtamant(scope.row.Id)"/>
          </el-tooltip>
          <el-tooltip content="Preview">
            <el-button type="primary" size="mini" icon="el-icon-view" circle @click="preview(scope.row.Id)"/>
          </el-tooltip>           
          <el-tooltip content="Anuleaza">
            <el-button type="warning" size="mini" icon="el-icon-edit" circle @click="anuleaza(scope.row.Id)"/>
          </el-tooltip> 
          <!-- <el-tooltip content="Print deviz">
            <el-button type="info" size="mini" icon="el-icon-printer" circle @click="print_deviz(scope.row.Id)"/>
          </el-tooltip>
          <el-tooltip content="Print inspectie">
            <el-button type="warning" size="mini" icon="el-icon-printer" circle @click="print_inspectie(scope.row.Id)" />
          </el-tooltip>       -->
          </div>    
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager"
    />
    <Previewdeviz   ref="preview_deviz" />

    <!-- <DevizProduse   ref="deviz_produse" /> -->

  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";
import Previewdeviz from '@/components/Preview_deviz';
import LocalSettings from "../../backend/LocalSettings";
// import DevizProduse from '@/components/Deviz_produse';

export default {
  name: "masini",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
    Previewdeviz,
    // DevizProduse,
  },
  data() {
    return {
      datePickerOptions: settings.datePickerOptions,
      device: "",
      Results: [],
      base_url: "",
      Info: {
        clienti: [],
      },
      Filters: {
        IdClient: "",
        Numar: "",
        An: "",
        TipAuto: "-1",
        DataDeschiderii: "",
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },
  methods: {
    async preview(id) {
      this.$refs.preview_deviz.show(id, 1);
    },   

    async print_consimtamant(id_deviz){      
      let isDev = '';
      if (LocalSettings.IS_DEV) { isDev = '/dev' }
      
      window.open( isDev + "/#/deviz_consimtamant_pdf/" + id_deviz, '_blank');
    },

    async anuleaza(id) {
      this.$prompt("Motivul anularii", "Anuleaza", {
          confirmButtonText: 'Anuleaza',
          cancelButtonText: 'Renunta',
      }).then(async ({value}) => {
        // console.log(value);
        // if (value == null) value = 'Nu a fost specificat un motiv';
        let response = await this.post('receptie/devize/anuleaza_deviz', {idDeviz: id, Motiv: value});
        if(response.success == 1) {
          this.$message({type: 'success', message: 'Devizul a fost anulat cu success.'});
          this.refresh_info();
        } else {
          this.$message({type: 'error', message: 'A intervenit o eroare in anularea devizului'});
        }
      }).catch(() => {});
     
    },   
    
    async inchide(id) {
      this.$prompt("Acest deviz va fi inchis cu statusul 'Lipsa operatiune'. Programarea va fi anulata! Va rugam sa specificati motivul", "Inchide", {
          confirmButtonText: 'Inchide',
          cancelButtonText: 'Renunta',
      }).then(async ({value}) => {
        let response = await this.post('receptie/devize/inchide_deviz_lipsa_operatiune', {idDeviz: id, Motiv: value});
        if(response.success == 1) {
          this.$message({type: 'success', message: 'Devizul a fost inchis cu success.'});
          this.refresh_info();
        } else {
          this.$message({type: 'error', message: 'A intervenit o eroare in inchiderea devizului'});
        }
      }).catch(() => {});
     
    },   
 
    async get_info() {
      var response = await this.post("receptie/devize/get_info");
      this.Info.clienti = response.clienti;
      // if (this.Filters.IdClient.length > 0)
      //   this.Filters.IdClient = this.Info.clienti[0].Id;
      this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("receptie/devize/get_devize_in_lucru", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("devize_in_lucru");
    },
    formatDate(value) {
      if (!value) return '';
      const d = new Date(value);
      const z = n => (n < 10 ? '0' + n : n);
      return `${z(d.getDate())}.${z(d.getMonth() + 1)}.${d.getFullYear()} ${z(d.getHours())}:${z(d.getMinutes())}`;
    },
    reset() {
      this.Filters = {
        IdClient: "",
        Numar: "",
        An: "",
        TipAuto: "-1",
        DataDeschiderii: "",
      };
      this.refresh_info();
    },

  },
  created() {
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      this.device = "phone"
    } else this.device = "computer"
  },
  mounted() {
    // if (!this.$has_right("Management")) {
    //   this.$router.push("/no-rights");
    //   return;
    // }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}



.input-element {
  width: 50%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }

  .phone-btn {
    padding-left: 20px;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  }

  .el-date-editor--daterange.el-input__inner {
    width: 300px;
  }

  .el-picker-panel__body {
    display: flex;
    flex-direction: column;
  }
}
</style>
